import { Box, Stack, TableCell, TableRow, Typography } from '@mui/material';
import { TextInputTableCell } from './TextInputTableCell';
import { ImageTableCell } from './ImageTableCell';
import { TableComponent } from 'components/TableComponent';
import { boStyle } from 'constants/content.constants';
import _ from 'lodash';
import { useContext } from 'react';
import { isSendExampleEmailContext } from 'pages/ContentApp';
import { TextInput } from 'components/Inputs';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { ButtonComponent } from 'components/ButtonComponent';
import { FileTableCell } from './FileTableCell';

interface IProps {
	section: any;
	selectedLanguage: string;
	tableHeaderItems?: string[];
	tableWith?: string;
	tableCellWidth?: string;
	paddingStyle?: string;
	planCardId?: number;
}

export const SingleLangTable = ({
	section,
	selectedLanguage,
	tableHeaderItems,
	tableWith,
	tableCellWidth,
	paddingStyle,
	planCardId,
}: IProps) => {
	const t = useAppSelector(selectTranslations);
	const textFieldGroupType = 'text';

	const { isSendExampleEmail, handleSendExampleEmail, onChangeEmailFields, emailFields } =
		useContext(isSendExampleEmailContext);

	const fileFieldGroupType = 'pdf';
	return (
		<TableComponent
			tableHeaderItems={tableHeaderItems || []}
			styleObj={{ minWidth: tableWith }}
			paddingStyle={paddingStyle}
			planCardId={planCardId}
		>
			{_.sortBy(section.fieldGroups, 'order')?.map((fieldGroup: any) => {
				return (
					<TableRow
						key={fieldGroup?.id}
						sx={{
							'& td, & th': {
								border: 0,
								padding: paddingStyle || '16px 16px 0px 16px',
							},
						}}
					>
						<TableCell
							sx={{
								width: tableCellWidth || '200px',
								verticalAlign: 'top',
								paddingTop: '20px!important',
							}}
						>
							<Typography variant="body">{fieldGroup?.displayTitle}</Typography>
						</TableCell>
						<ConditionalStack condition={fieldGroup.boStyle === boStyle.STACK_INPUTS}>
							{fieldGroup?.fieldGroupItems?.map((fieldGroupItem: any) => {
								if (fieldGroupItem?.type === textFieldGroupType) {
									return (
										<TextInputTableCell
											key={fieldGroupItem?.id}
											item={fieldGroupItem}
											selectedLanguage={selectedLanguage}
										/>
									);
								}
								if (fieldGroupItem?.type === fileFieldGroupType) {
									return <FileTableCell key={fieldGroupItem?.id} item={fieldGroupItem} />;
								} else {
									return <ImageTableCell key={fieldGroupItem?.id} item={fieldGroupItem} />;
								}
							})}
						</ConditionalStack>
					</TableRow>
				);
			})}
			{isSendExampleEmail ? (
				<TableRow
					key={'example-email-button'}
					sx={{
						'& td, & th': {
							border: 0,
							padding: paddingStyle || '16px 16px 0px 16px',
						},
					}}
				>
					<TableCell
						sx={{
							width: tableCellWidth || '200px',
							verticalAlign: 'top',
							paddingTop: '20px!important',
						}}
					>
						<Typography variant="body">{t('label.send_example_email')}</Typography>
					</TableCell>
					<TableCell
						sx={{
							// width: tableCellWidth || '200px',
							verticalAlign: 'top',
							paddingTop: '20px!important',
						}}
					>
						<Stack flexDirection={'row'} alignItems="center" gap="32px">
							<TextInput
								textFieldStyle={{
									width: '200px !important',
									direction: 'ltr',
								}}
								value={''}
								label=""
								onChange={(text: string) => onChangeEmailFields(0, text)}
							/>
							<ButtonComponent
								disabled={
									!emailFields?.email?.length
									// !currentPermission
								}
								handleClick={() => {
									handleSendExampleEmail();
								}}
								text={t('button.send_email')}
							/>
						</Stack>
					</TableCell>
				</TableRow>
			) : (
				<></>
			)}
		</TableComponent>
	);
};

interface IStackProps {
	children: any;
	condition: boolean;
}

export const ConditionalStack = ({ children, condition }: IStackProps) => {
	return <>{condition ? <Stack>{children}</Stack> : children}</>;
};
